(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7695],{

/***/ 13200:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events",
      function () {
        return __webpack_require__(80445);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function CardCTA(param) {
    var className = param.className, label = param.label;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('rounded border border-rose py-2 px-4 text-sm font-bold text-rose group-hover:border-cornflower group-hover:text-cornflower', className),
        children: [
            label,
            " →"
        ]
    }));
};


/***/ }),

/***/ 45113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46831);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_resolvers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16019);
/* harmony import */ var _components_DefaultCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16190);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CardGrid(param) {
    var entries = param.entries, _Component = param.Component, Component = _Component === void 0 ? _components_DefaultCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : _Component, linkSubpath = param.linkSubpath, truncatedText = param.truncatedText;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "-mx-6 flex flex-wrap",
        children: entries.map(function(entry) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-12 flex w-full px-6 md:w-1/2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, entry, {
                    subTitle: truncatedText ? (0,_utils_resolvers__WEBPACK_IMPORTED_MODULE_3__/* .truncateText */ .a)({
                        text: entry.subTitle
                    }) : entry.subTitle,
                    linkPath: "/".concat(linkSubpath, "/").concat(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_1___default()(entry.slug, {
                        lower: true
                    }))
                }))
            }, entry.id);
        })
    }));
};


/***/ }),

/***/ 83228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function CardLink(param) {
    var children = param.children, className = param.className, externalUrl = param.externalUrl, linkPath = param.linkPath;
    var linkClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex flex-1 flex-col group');
    if (externalUrl) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: externalUrl,
            target: "_blank",
            rel: "nofollow noopener noreferrer",
            className: linkClassName,
            children: children
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
        href: linkPath,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: linkClassName,
            children: children
        })
    }));
};


/***/ }),

/***/ 16190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DefaultCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var _components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37324);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27910);
/* harmony import */ var _components_CardLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83228);
/* harmony import */ var _components_CardCTA__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13690);






function DefaultCard(param) {
    var coverImage = param.coverImage, externalUrl = param.externalUrl, linkPath = param.linkPath, id = param.id, subTitle = param.subTitle, title = param.title;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: "flex flex-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_CardLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            externalUrl: externalUrl,
            linkPath: linkPath,
            children: [
                coverImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "rounded-lg",
                        src: coverImage.url,
                        width: coverImage.width,
                        height: coverImage.height,
                        alt: coverImage === null || coverImage === void 0 ? void 0 : coverImage.alt
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "-mt-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        level: 4,
                        className: "mb-2",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "flex-grow",
                    children: subTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardCTA__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        label: "Learn More"
                    })
                })
            ]
        })
    }, id));
};


/***/ }),

/***/ 80445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Events; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Layout/Vanilla.tsx + 22 modules
var Vanilla = __webpack_require__(1635);
// EXTERNAL MODULE: ./src/components/CardGrid.js
var CardGrid = __webpack_require__(45113);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/EmptyState.tsx


function EmptyState(param) {
    var className = param.className, _message = param.message, message = _message === void 0 ? "Please check back soon" : _message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: classnames_default()("text-center text-lg font-bold text-gray-600", className),
        children: message
    }));
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/components/renderers/Paragraph.tsx
var Paragraph = __webpack_require__(37324);
// EXTERNAL MODULE: ./src/components/renderers/Heading.tsx
var Heading = __webpack_require__(27910);
// EXTERNAL MODULE: ./src/components/CardCTA.js
var CardCTA = __webpack_require__(13690);
// EXTERNAL MODULE: ./src/components/CardLink.js
var CardLink = __webpack_require__(83228);
// EXTERNAL MODULE: ./src/components/Pill.js
var Pill = __webpack_require__(79506);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(63049);
;// CONCATENATED MODULE: ./src/components/EventCard.js








function EventCard(param) {
    var coverImage = param.coverImage, externalUrl = param.externalUrl, linkPath = param.linkPath, id = param.id, starts = param.starts, subTitle = param.subTitle, title = param.title, type = param.type;
    var friendlyStartDate = (0,date/* formatDateWithTime */.k)(starts);
    var isUpcoming = new Date(starts) > new Date();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: "flex flex-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardLink/* default */.Z, {
            externalUrl: externalUrl,
            linkPath: linkPath,
            children: [
                coverImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: coverImage.url,
                        width: coverImage.width,
                        height: coverImage.height,
                        alt: coverImage.alt,
                        className: "rounded-lg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-mt-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        level: 4,
                        className: "mb-2",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-mx-1 -my-1 flex flex-wrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                        label: type
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                    className: "flex-grow",
                    children: subTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        isUpcoming && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCTA/* default */.Z, {
                            label: "RSVP"
                        }),
                        friendlyStartDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-cornflower",
                            children: friendlyStartDate
                        })
                    ]
                })
            ]
        })
    }, id));
};

// EXTERNAL MODULE: ./src/components/Hero.js + 5 modules
var Hero = __webpack_require__(52456);
// EXTERNAL MODULE: ./src/components/Section.tsx
var Section = __webpack_require__(67576);
// EXTERNAL MODULE: ./src/components/SectionHero.js
var SectionHero = __webpack_require__(38790);
;// CONCATENATED MODULE: ./src/pages/events.js








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __N_SSG = true;
function Events(param1) {
    var page = param1.page, events = param1.events, preview = param1.preview;
    var ref = _slicedToArray(events.reduce(function(param, e) {
        var _param = _slicedToArray(param, 2), u = _param[0], p = _param[1];
        return new Date(e.starts) > new Date() ? [
            _toConsumableArray(u).concat([
                e
            ]),
            p
        ] : [
            u,
            _toConsumableArray(p).concat([
                e
            ])
        ];
    }, [
        [],
        []
    ]), 2), upcomingEvents = ref[0], pastEvents = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Vanilla/* default */.Z, {
        seo: page,
        preview: preview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, _objectSpread({}, page))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                colour: "light",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero/* default */.Z, {
                        title: "Upcoming Events"
                    }),
                    !upcomingEvents.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState, {
                        message: "No upcoming events"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardGrid/* default */.Z, _objectSpread({
                        entries: upcomingEvents,
                        Component: EventCard
                    }, page))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero/* default */.Z, {
                        title: "Past Events"
                    }),
                    !pastEvents.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState, {
                        message: "No past events"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardGrid/* default */.Z, _objectSpread({
                        entries: pastEvents,
                        Component: EventCard,
                        truncatedText: true
                    }, page))
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 63049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; },
/* harmony export */   "k": function() { return /* binding */ formatDateWithTime; }
/* harmony export */ });
var normalizeDate = function(dateToNormalize) {
    var date = new Date(dateToNormalize);
    return new Date(date.getTime() - date.getTimezoneOffset() * -60000);
};
function formatDate(date) {
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
    }).format(normalizeDate(date));
}
function formatDateWithTime(date) {
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false
    }).format(normalizeDate(date));
}


/***/ }),

/***/ 16019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ truncateText; }
/* harmony export */ });
function truncateText(param) {
    var text = param.text, _length = param.length, length = _length === void 0 ? 24 : _length;
    if (!text) return null;
    var splitText = text.split(" ");
    if (splitText.length < length) return text;
    return "".concat(splitText.splice(0, length).join(" "), "...");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,3353,6831,5343,1635,2456,9774,2888,179], function() { return __webpack_exec__(13200); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);